/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
    <v-layout row wrap class="card-shadow" text-xs-center v-if="dialog == true">
      <v-flex xs6 sm6 :class="dynamicCol" v-for="item in items" :key="item.key" class="single-card">
        <Card class="card-header">
      <v-flex sm12>
    <v-flex xs12 class="head">{{ $t(item.name) }} ({{ item.unit }})</v-flex>
      <v-layout row wrap text-xs-center>
        <v-flex sm3>
          <div class="sub-title">{{ $t('LIVE') }}</div>
          <div v-if ="item.live == null" class="sub-value">{{ $t('No Data') }}</div>
          <div v-else class="sub-value">{{item.live}}</div>
        </v-flex>
        <v-flex sm3>
          <div class="sub-title">{{ $t('MAX') }}</div>
          <div v-if ="item.max == null" class="sub-value">{{ $t('No Data') }}</div>
          <div v-else class="sub-value">{{item.max}}</div>
        </v-flex>
        <v-flex sm3>
          <div class="sub-title">{{ $t('MIN') }}</div>
          <div v-if ="item.min == null" class="sub-value">{{ $t('No Data') }}</div>
          <div v-else class="sub-value">{{item.min}}</div>
        </v-flex>
        <v-flex sm3>
          <div class="sub-title">{{ $t('AVG') }}</div>
          <div v-if ="item.avg == null" class="sub-value">{{ $t('No Data') }}</div>
          <div v-else class="sub-value">{{item.avg}}</div>
        </v-flex>
      </v-layout>
    </v-flex>
    </Card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import trackerService from '@/services/tracker'
import { EventBus } from '@/services/event-bus'

export default {
  props: ['date'],
  data() {
    return {
      start_date: '',
      end_date: '',
      interval: null,
      dialog: true,
      items: []
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedPlantId'
    ]),
    dynamicCol: function () {
      if (this.items.length == 1) {
        return {
          'md12': true
        }
      } else if (this.items.length == 2) {
        return {
          'md6': true,
        }
      } else if (this.items.length == 3) {
        return {
          'md4': true,
        }
      } else if (this.items.length == 4) {
        return {
          'md3': true
        }
      } else if (this.items.length == 5) {
        return {
          'md2': true,
          'card-5': true
        }
      } else if (this.items.length == 6) {
        return {
          'md2': true
        }
      } else {
        return {
          'md2': true
        }
      }
    }
  },
  created() {
    EventBus.$on('plantChanged', this.plantChange)
  },
  mounted() {
    this.start_date = this.date
    this.end_date = this.date
    this.selectedPlant = this.getSelectedPlantId
    this.getHeaderData()
    this.interval = setInterval(
      () => {
        this.getHeaderData()
      },
      60000
    )
  },
  beforeDestroy() {
    EventBus.$off('plantChanged', this.plantChange)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    async getHeaderData() {
      let param = await this.getHeaderParam()
      let response = await trackerService.getHeaderData(param)
      if (response.status === 200) {
        this.items = response.data
      }
    },
    expand: function () {
      if (this.dialog == true) {
        this.dialog = false
      } else {
        this.dialog = true
      }
    },
    plantChange: function (plantId) {
      this.selectedPlant = plantId
      this.getHeaderData()
    },
    dateChange: function (startDate, endDate) {
      if (this.start_date === '' && this.end_date === '') return
      this.start_date = startDate
      this.end_date = endDate
      this.getHeaderData()
    },
    getHeaderParam: function () {
      return {
        plantId: this.selectedPlant,
        dateFrom: this.start_date,
        dateTo: this.end_date
      }
    }
  },
  watch: {
    date(val) {
      if (this.start_date === '' && this.end_date === '') return
      this.start_date = val
      this.end_date = val
      this.getHeaderData()
    }
  }
}
</script>
<style scoped>
  @import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
  @import url("https://fonts.googleapis.com/css?family=Work+Sans&display=swap");

  .theme--dark .head{
    font-size: 16px !important;
    font-weight: bold;
    /* color: #fff; */
  }
  .theme--light .head{
    font-size: 16px !important;
    font-weight: bold;
    /* color: #000; */
  }
  .sub-title{
    /* color: #888a8e; */
    font-size: 18px;
  }
  .theme--light .sub-value{
    font-size: 20px;
    /* color: #000 !important; */
}
  .theme--dark .sub-value{
    font-size: 16px;
    /* color: #fff; */
 }
  .v-card {
    display: flex;
    align-items: center;
    /* box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.2), */
      /* 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12); */
  }

  .card-header {
    border-left: 6px solid;
    border-color: var(--v-primaryText-base) !important;
  }
  .single-card {
    padding: 4px;
  }
  .card-5 {
    min-width: 20%;
  }

  @media only screen and (min-width: 320px) and (max-width: 600px) {
    .ag-card-number {
      font-size: 20px !important;
    }
  }
</style>
